import {z} from "zod"
import {GraphNode} from "#graph/nodes/graph/node"
import {registerNode} from "#graph/decorators/register-node"
import type {Evaluator} from "#graph/evaluators/types"
import {StructDefinition} from "#graph/nodes/struct/definition"

export abstract class Struct<
    StructType extends {
        [key: string]: unknown
    },
> extends GraphNode<ReturnType<typeof StructDefinition<StructType>>> {
    override run = async (evaluator: Evaluator) => {
        return evaluator.getAll(this.parameters.struct) as Promise<StructType>
    }

    override runSync = (evaluator: Evaluator) => {
        return evaluator.getAllSync(this.parameters.struct) as StructType
    }
}

@registerNode
export class NumberStruct extends Struct<{a: number; b: number}> {
    static nodeClass = "NumberStruct"
    static definition = StructDefinition({
        a: z.number(),
        b: z.number(),
    })
}
